import { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { COMPANY, NAV_LINKS } from '../lib/site';
import { Button } from './ui/button';

export const Header = ({ onOpenQuote }) => {
    const [scrolled, setScrolled] = useState(false);
    const [mobileOpen, setMobileOpen] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 12);
        onScroll();
        window.addEventListener('scroll', onScroll, { passive: true });
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    useEffect(() => { setMobileOpen(false); }, [location.pathname]);

    return (
        <header
            data-testid="site-header"
            className={`sticky top-0 z-50 transition-all duration-300 backdrop-blur-xl ${
                scrolled ? 'bg-white/85 border-b border-border/60 shadow-[0_4px_24px_-12px_rgba(17,47,34,0.15)]' : 'bg-white/40 border-b border-transparent'
            }`}
        >
            <div className="container-axion flex items-center justify-between h-[72px]">
                <Link to="/" data-testid="header-logo" className="flex items-center gap-2 group">
                    <img
                        src="/logo.png"
                        alt="Axion Cleaning Limited"
                        className="h-12 md:h-14 w-auto"
                    />
                </Link>

                <nav className="hidden lg:flex items-center gap-9" aria-label="Primary">
                    {NAV_LINKS.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            data-testid={l.testid}
                            className={({ isActive }) =>
                                `text-sm font-outfit transition-colors ${isActive ? 'text-foreground' : 'text-muted-foreground hover:text-foreground'}`
                            }
                            end={l.to === '/'}
                        >
                            {l.label}
                        </NavLink>
                    ))}
                </nav>

                <div className="flex items-center gap-2">
                    <Button
                        data-testid="header-quote-button"
                        onClick={onOpenQuote}
                        className="hidden sm:inline-flex rounded-full bg-primary text-primary-foreground font-outfit font-medium px-5 py-2.5 h-auto text-sm hover:-translate-y-0.5 hover:shadow-[0_14px_28px_-12px_rgba(17,47,34,0.55)] transition-all"
                    >
                        Get a Free Quote
                    </Button>
                    <button
                        onClick={() => setMobileOpen((v) => !v)}
                        data-testid="mobile-menu-toggle"
                        className="lg:hidden grid place-items-center w-10 h-10 rounded-full border border-border bg-white"
                        aria-label="Toggle navigation"
                    >
                        {mobileOpen ? <X className="w-4 h-4" /> : <Menu className="w-4 h-4" />}
                    </button>
                </div>
            </div>

            {mobileOpen && (
                <div className="lg:hidden border-t border-border bg-white">
                    <div className="container-axion py-6 flex flex-col gap-1">
                        {NAV_LINKS.map((l) => (
                            <NavLink
                                key={l.to}
                                to={l.to}
                                data-testid={`mobile-${l.testid}`}
                                className={({ isActive }) =>
                                    `py-3 px-2 rounded-md text-base font-outfit ${isActive ? 'text-foreground bg-muted' : 'text-muted-foreground'}`
                                }
                                end={l.to === '/'}
                            >
                                {l.label}
                            </NavLink>
                        ))}
                        <Button
                            onClick={() => { setMobileOpen(false); onOpenQuote(); }}
                            className="mt-4 rounded-full bg-primary text-primary-foreground"
                            data-testid="mobile-quote-button"
                        >
                            Get a Free Quote
                        </Button>
                    </div>
                </div>
            )}
        </header>
    );
};
